export const timeZone = 'Europe/Zurich';

export const initialStatus = 'requested';

export const minimumDurations = {
  private: 4,
  hotel: 3,
  partyEvents: 3,
};
